module.exports = true;


//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/babel-runtime/~/core-js/library/modules/$.library.js
// module id = 47
// module chunks = 0